import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import StoryPage from "./pages/StoryPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ForumPage from "./pages/ForumPage";
import PostDetailPage from "./pages/PostDetailPage";
import AdminPage from "./pages/AdminPage";

export default function App() {
  return (
    <AuthProvider>
      <ReactLenis root options={{ lerp: 0.09 }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/story" element={<StoryPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/forum" element={<ForumPage />} />
            <Route path="/forum/post/:id" element={<PostDetailPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </ReactLenis>
    </AuthProvider>
  );
}
